/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Beginbeschaftigungmeldung2Inputs */



/**

* @param {_Field_Beginbeschaftigungmeldung2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_beginbeschaftigungmeldung2 = /** @type {((inputs?: _Field_Beginbeschaftigungmeldung2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Beginbeschaftigungmeldung2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Beginn")
});
export { _field_beginbeschaftigungmeldung2 as "_field_beginBeschaftigungMeldung" }